module.exports = __webpack_public_path__ + "img/logo.1a93f05e.png";